<template>
  <div class="select">
    <!--Area-->
    <div
      class="input-area"
      :class="{ 'is-active': isOpen, 'is-error': isError }"
      @click="openMenu"
    >
      <!--If is selected-->
      <div v-if="selected" class="selected">
        <div v-if="selected.icon" class="option-icon"></div>
        <span class="option-value">{{ selected.label }}</span>
      </div>

      <!--If is empty-->
      <div v-if="!selected" class="not-selected">
        <span class="option-value placehoder">{{ placeholder }}</span>
      </div>

      <dropdown-icon class="chevron"></dropdown-icon>
    </div>

    <!--Options-->
    <transition name="slide-in">
      <div v-if="isOpen" class="input-options">
        <div v-if="options.length > 5" class="select-search">
          <input
            ref="search"
            v-model="query"
            type="text"
            placeholder="Search ..."
            class="search-input focus-border-theme"
          />
        </div>
        <ul class="option-list">
          <li
            v-for="(option, i) in optionList"
            :key="i"
            class="option-item"
            @click="selectOption(option)"
          >
            <div v-if="option.icon" class="option-icon"></div>
            <span class="option-value">{{ option.label }}</span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
//import { ChevronDownIcon, Edit2Icon, UserIcon } from 'vue-feather-icons'
import { debounce, omitBy } from 'lodash'
import DropdownIcon from '@main/js/components/icons/dropdown'

export default {
  name: 'SelectInput',
  components: { DropdownIcon },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    isError: {
      type: [String, Boolean],
      default: '',
    },
    defaultValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchedResults: undefined,
      selected: undefined,
      isOpen: false,
      query: '',
    }
  },
  computed: {
    isSearching() {
      return this.searchedResults && this.query !== ''
    },
    optionList() {
      return this.isSearching ? this.searchedResults : this.options
    },
  },
  watch: {
    query: debounce(function (val) {
      this.searchedResults = omitBy(this.options, (string) => {
        return !string.label.toLowerCase().includes(val.toLowerCase())
      })
    }, 200),
  },

  /*  mounted() {
    if (this.defaultValue)
      this.selected = this.options.find(
        option => option.value === this.defaultValue
      )
  },*/
  created() {
    //this.$nextTick(() => {
    if (this.defaultValue)
      this.selected = this.options.find(
        (option) => option.value === this.defaultValue,
      )
    //})
  },
  methods: {
    selectOption(option) {
      // Emit selected
      this.$emit('input', option.value)

      // Get selected
      this.selected = option

      // Close menu
      this.isOpen = false
    },
    openMenu() {
      this.isOpen = !this.isOpen

      if (this.isOpen && this.options.length > 5) {
        this.$nextTick(() => this.$refs.search.focus())
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.option-list {
  padding: 10px 10px 10px 10px;
  margin-bottom: 0;
}

.select {
  position: relative;
  user-select: none;
  width: 100%;
}

.select-search {
  background: white;
  position: sticky;
  top: 0;
  padding: 8px 10px 8px 10px;

  .search-input {
    border: 1px solid transparent;
    background: #f0f0f0;
    border-radius: 0.25rem;
    padding: 8px 20px;
    appearance: none;
    font-weight: 600;
    outline: 0;
    width: 100%;
  }
}

.input-options {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
  background: white;
  border-radius: 0.25rem;
  position: absolute;
  overflow: hidden;
  top: 39px;
  left: 0;
  right: 0;
  z-index: 9;
  max-height: 295px;
  overflow-y: auto;

  .option-item {
    padding: 8px 10px;
    display: block;
    cursor: pointer;

    &:hover {
      color: #000000;
      background: #f6f6f6;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.input-area {
  border: 1px solid #dddddd;
  justify-content: space-between;
  //box-shadow: 0 1px 5px rgba(0, 0, 0, 0.12);
  //background: $light_mode_input_background;
  @include transition(150ms);
  align-items: center;
  border-radius: 0.25rem;
  padding: 0.4375rem 0.875rem;
  display: flex;
  outline: 0;
  width: 100%;
  cursor: pointer;

  .chevron {
    @include transition(150ms);
  }

  &.is-active {
    //box-shadow: 0 0 7px rgba($theme, 0.3);

    .chevron {
      @include transform(rotate(180deg));
    }
  }

  &.is-error {
    border-color: #000000;
    box-shadow: 0 0 7px rgba(#ffff00, 0.3);
  }
}

.option-icon {
  width: 20px;
  display: inline-block;

  svg {
    margin-top: -4px;
    vertical-align: middle;
  }
}

.option-value {
  width: 100%;
  vertical-align: middle;

  &.placehoder {
    color: rgba(#000000, 0.5);
  }
}

.slide-in-enter-active {
  transition: all 150ms ease;
}

.slide-in-enter /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-50px);
}
</style>
